import { bool, object, shape, string } from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import BundleBadge from '../../../ProductBadges/BundleBadge';
import styles from './ProductBadge.css';

const cx = classNames.bind(styles);

const ProductBadge = ({ badge, playVideo, upperBadge }) => {
    const activeBadge = badge || upperBadge;

    const Badge = () => {
        const badgeClasses = [
            'absolute',
            'bg-white-100',
            'border-1 border-gray-300 border-solid',
            'font-open-sans-bold',
            'inline-block',
            'lg:py-1',
            'px-1 py-half',
            'rounded-r-medium',
            'shadow-medium',
            'text-gray-400 text-xsmall',
            'z-10',
            cx('product-badge'),
        ].join(' ');

        return activeBadge && activeBadge.text ? (
            <div className={badgeClasses}>{activeBadge.text}</div>
        ) : null;
    };

    if (playVideo) {
        return null;
    }

    return activeBadge.type === 'bundle' ? <BundleBadge text={activeBadge.text} /> : <Badge />;
};

ProductBadge.propTypes = {
    badge: shape({
        text: string,
        type: string,
    }),
    playVideo: bool,
    upperBadge: object,
};

ProductBadge.defaultProps = {
    badge: {},
    playVideo: false,
    upperBadge: {},
};

export default ProductBadge;
